'use strict';

import type { IndMarx } from '../../Entities/Ind/IndMarx';
import { EntityCollection } from '../EntityCollection';

export class IndMarxCollection extends EntityCollection<IndMarx> {}
